// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  assembleQuery,
  deleteWrapper,
  fetchWrapper,
  postFormDataWrapper,
  postWrapper,
  putWrapper,
} from 'helpers/api'

export const copyAntennaSpecById = (antennaSpecId, query) => postWrapper(`/antenna-specs/copy/${antennaSpecId}${query}`)

export const deleteAntennaSpecById = id => deleteWrapper(`/antenna-specs/${id}`)

export const deleteAntennaSpecCommentById = (antennaSpecId, antennaSpecCommentId) => (
  deleteWrapper(`/antenna-specs/${antennaSpecId}/comments/${antennaSpecCommentId}`)
)

export const deleteAntennaSpecCommentFile = antennaSpecCommentFileId => (
  deleteWrapper(`/antenna-spec-comment-files/${antennaSpecCommentFileId}`)
)

export const deleteAntennaSpecCSVMapping = id => deleteWrapper(`/antenna-spec-csv-mappings/${id}`)

export const fetchAntennaApplications = () => fetchWrapper('/antenna-applications')

export const fetchAntennaClassifications = () => fetchWrapper('/classifications')

export const fetchAntennaCompanies = (c = '') => fetchWrapper(`/antenna-specs/companies${c}`)

export const fetchAntennaCompliances = () => fetchWrapper('/compliances')

export const fetchAntennaCSVMappings = (q = '') => (
  fetchWrapper(`/antenna-spec-csv-mappings${q}`)
)

// this is not used anywhere save for below.
// so no need to export currently.
// this is separated for modularity and readabilty
const fetchAntennaFamilies = (f = '') => fetchWrapper(`/antenna-families${f}`)

// builds a query to support any values which should be escaped.
// this specific query is used in a few different scenarios across the application
export const fetchAntennaFamiliesContaining = (value = '') => {
  const query = [{
    field: 'antennaFamilyContains',
    value,
  }]
  return fetchAntennaFamilies(assembleQuery(query))
}

export const fetchAntennasByQuery = q => fetchWrapper(`/antennas${q}`)

// this value can have characters which should be escaped.
export const fetchAntennaSpecByAntennaCode = c => (
  fetchWrapper(`/antenna-specs/antenna-code/${encodeURIComponent(c)}`)
)

export const fetchAntennaSpecById = id => fetchWrapper(`/antenna-specs/${id}`)

export const fetchAntennaSpecsByQuery = q => fetchWrapper(`/antenna-specs${q}`)

const fetchAntennaSpecsByModelNumbers = (m = '') => (
  fetchWrapper(`/antenna-specs/model-numbers${m}`)
)

// builds a query speifically for the radio modulation model number
export const fetchAntennaSpecsByModelNumbersContaining = (value = '') => {
  const query = [{
    field: 'modelNumberContains',
    value,
  }]
  return fetchAntennaSpecsByModelNumbers(assembleQuery(query))
}

export const fetchAntennaStatuses = () => fetchWrapper('/statuses')

export const fetchAntennaPatternPolarizations = () => fetchWrapper('/antenna-pattern-polarizations')

export const fetchAntennaPolarizations = () => fetchWrapper('/polarization-capabilities')

export const fetchNewAntennaCode = () => fetchWrapper('/antenna-specs/new-antenna-code')

export const getAntennaDiscriminationCalculations = d => (
  postWrapper('/antenna-specs/antenna-discrimination-calculations', d)
)

export const postAntennaComment = (entityId, comment) => (
  postFormDataWrapper(`/antenna-specs/${entityId}/comments`, comment)
)

export const postAntennaCSVMapping = mapping => (
  postWrapper('/antenna-spec-csv-mappings', mapping)
)

export const postNewAntennaFamily = f => postWrapper('/antenna-families', f)

export const postNewAntennaSpec = s => postWrapper('/antenna-specs', s)

export const putNewAntennaSpec = s => putWrapper('/antenna-specs', s)
